import React, { useState, useEffect } from 'react';
import { api } from '../services/apiClient';
import { useCart } from '../context/CartContext';
import { useSettings } from '../hooks/useSettings';
import ArtworkCard from '../components/ArtworkCard';

const GalleriaPage = () => {
  const [illustrations, setIllustrations] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const { addItem } = useCart();
  const { settings } = useSettings();

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    setLoading(true);
    try {
      // Fetch only published illustrations with categories
      const illustrationsData = await api.illustrations.list('pubblicato');
      if (illustrationsData) {
        setIllustrations(illustrationsData);
      }

      // Fetch categories for filter
      const categoriesData = await api.categories.list();
      if (categoriesData) {
        setCategories(categoriesData);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }

  // Filter illustrations by active category
  const filteredIllustrations = activeCategory
    ? illustrations.filter((ill) => ill.categories?.id === activeCategory)
    : illustrations;

  return (
    <div className="min-h-screen bg-brand-light pt-20 md:pt-24">
      {/* Page Header */}
      <div className="py-12 md:py-20 px-4 md:px-6 lg:px-8 border-b border-brand-main/20">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="font-display text-6xl md:text-7xl italic font-light text-brand-ink mb-4">
            Galleria
          </h1>
          <p className="font-body text-lg text-brand-muted">
            Scopri la collezione completa di illustrazioni originali
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-12 md:py-16">
        {/* Category Filter */}
        <div className="mb-12">
          <div className="flex gap-2 overflow-x-auto pb-4 -mx-4 px-4 md:mx-0 md:px-0">
            <button
              onClick={() => setActiveCategory(null)}
              className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                activeCategory === null
                  ? 'bg-brand-dark text-white'
                  : 'bg-white border border-brand-main text-brand-dark hover:bg-brand-light'
              }`}
            >
              Tutte
            </button>
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setActiveCategory(cat.id)}
                className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                  activeCategory === cat.id
                    ? 'bg-brand-dark text-white'
                    : 'bg-white border border-brand-main text-brand-dark hover:bg-brand-light'
                }`}
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        {/* Grid */}
        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {[...Array(8)].map((_, i) => (
              <div
                key={i}
                className="bg-brand-main/30 animate-pulse rounded-lg aspect-square"
              />
            ))}
          </div>
        ) : filteredIllustrations.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredIllustrations.map((illustration) => (
              <ArtworkCard
                key={illustration.id}
                illustration={illustration}
                onAddToCart={() => addItem(illustration)}
                showPrice={settings.show_prices}
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-20">
            <p className="font-body text-lg text-brand-muted">
              Nessuna opera trovata in questa categoria.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default GalleriaPage;
